<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("assigned_regions.supervisor") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="supervisorFilter"
          :options="userOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:supervisorFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("assigned_regions.sector") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sectorFilter"
          :options="sectorOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:sectorFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("assigned_regions.scheduled") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="scheduledFilter"
          :options="scheduledOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:scheduledFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    vSelect,
  },
  props: {
    userOptions: {
      type: Array,
      default: () => [],
    },
    sectorOptions: {
      type: Array,
      default: () => [],
    },
    supervisorFilter: {
      type: [Number, String, Boolean, null],
      default: null,
    },
    sectorFilter: {
      type: [Number, String, Boolean, null],
      default: null,
    },
    scheduledFilter: {
      type: [Number, String, Boolean, null],
      default: null,
    },
  },
  computed: {
    scheduledOptions() {
      return [
        { value: 1, label: this.$t("assigned_regions.programmed") },
        { value: 0, label: this.$t("assigned_regions.manual_change") },
      ];
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
